<template>
    <section class="container vue-styles">
        <spinner v-if="loading" />
        
        <div 
            v-else

            class="grid md:grid-cols-3 gap-4"
        >
            <div class="md:col-span-2">                
                <div v-if="store.data.fac_type_membership.errors.value.display_error">
                    <p class="text-red text-center font-bold text-lg">{{ store.data.fac_type_membership.errors.value.display_error[0] }}</p>
                </div>
                <template v-else>
                    <div class="flex items-center">
                        <profile-picture 
                            class="shrink-0" 
                        
                            :member="memberType?.member ?? {}"  
                        />

                        <div class="w-full md:w-auto">
                            <member-title 
                                :membership="membership"
                                subtitle-colour="text-red"
                            />
                        </div>
                    </div>

                    <div 
                        v-if="description"
                        v-html="description?.answer"
                        
                        class="my-4 text-sub" 
                    />

                    <member-details :member="memberType?.member ?? {}" />
                </template>

                <div 
                    v-if="hasRegisterRedirect"
                    class="flex gap-2"
                >
                    <a class="btn btn--secondary mt-2" :href="registerRedirect">Back to Register Search</a>

                    <a class="btn btn--secondary mt-2" :href="searchUrl">Go to Directory Search</a>
                </div>

                <a
                    v-else
                    class="btn btn--secondary mt-2" 
                    :href="searchUrl"
                >
                    Back to Search
                </a>
            </div>
            <div v-if="!store.data.fac_type_membership.errors.value.display_error">
                <sidebar :membership="membership" />
            </div>
        </div>
    </section>
</template>

<script setup>
    import { onBeforeMount, computed } from 'vue'
    import store from './state/store'
    import ProfilePicture from './components/Results/IndividualResult/ProfilePicture.vue'
    import MemberTitle from './components/Results/IndividualResult/Title.vue'
    import MemberDetails from './components/Results/IndividualResult/Details.vue'
    import Sidebar from './components/Results/IndividualResult/Sidebar.vue'
    import Spinner from '@app/components/loading/Spinner.vue'

    const props = defineProps({
        facTypeMembership: String
    })

    onBeforeMount(async () => {
        store.data.fac_type_membership.api.parameters.value.fac_type_membership = props.facTypeMembership
        await store.data.fac_type_membership.api.execute()

        store.data.fac_type.api.parameters.value.fac_type = store.data.fac_type_membership.details.value.fac_type.slug
        
        store.data.fac_type.api.execute()
    })

    const loading = computed(() => store.data.fac_type_membership.loading.value || store.data.fac_type.loading.value)

    const searchUrl = computed(() => store.rootSearchUrl.value)

    const membership = computed(() => store.data.fac_type_membership.details.value)
    const memberType = computed(() => store.data.fac_type_memberships.getMemberType(membership.value))

    const description = computed(() => store.memberFieldsForSection('description', memberType.value?.member ?? {})[0] ?? false)

    const hasRegisterRedirect = computed(() => new URL(window.location).searchParams.get('redirect') === 'register')
    const registerRedirect = computed(() => {
        let url = store.facSearch('register')?.url

        if(!url){
            return false
        }

        url = new URL(url)
        url.searchParams.set('action', 'search')

        return url.toString()
    })
</script>